export enum EUserRole {
	ALUMNO = 'ALUMNO',
	DOCENTE = 'DOCENTE',
	AUDITOR = 'AUDITOR',
	ADMINISTRADOR = 'ADMINISTRADOR',
}

export interface IUser {
	id: number;
	firstName: string;
	lastName: string;
	email: string;
	role: EUserRole;
	avatarUrl: string | null;
}
